import React, { Component } from "react";
import styles from "./PreparePresentation.local.scss";
import Slide from "../Dashboard/Slide";
import NotFoundV2 from "../NotFound/NotFoundV2";
import ReactPaginate from "react-paginate";
import AnnexeIframe from "../Common/iframes/AnnexeIframe";
import _ from "i18n";
import { connect } from "react-redux";
import { setPresentationCurrentSlideIndex } from "Actions";
import classnames from "classnames";
import { setCommentSlideCode } from "Actions";
import browserHistory from "history/createBrowserHistory";

class SlidesPresentation extends Component {
  constructor(props) {
    super(props);

    const indexString = window.location.href.split("/")[5];
    const index =
      indexString && indexString.includes("?")
        ? Number(indexString.split("?")[0] - 1)
        : Number(indexString - 1);

    this.state = {
      index: index >= 0 || index < this.props.data.slides.length ? index : 0
      // nbSlides: this.props.data.slides.length,
      // slidesList: clonedeep(this.props.data.slides),
      // slides: clonedeep(this.props.data.slides)
    };
  }

  componentDidMount() {
    const {
      dispatch,
      data: { slides }
    } = this.props;
    let { index } = this.state;

    // // this.addExtraSlides();
    // if (!slidesList[index]) {
    //   index = 0;
    //   this.setState({ index: 0 });
    // }
    //to refactor
    if (index >= slides.length) {
      if (index < 2000) {
        this.handleSlidePageChange({ selected: 0 });
      }
    } else {
      dispatch(setPresentationCurrentSlideIndex(index));
      dispatch(setCommentSlideCode(slides[index].code));
    }
  }

  // componentDidUpdate(
  //   prevProps: Readonly<P>,
  //   prevState: Readonly<S>,
  //   snapshot: SS
  // ) {
  //   const { slidesList } = this.state;
  //   const {
  //     data: { slides },
  //     presentationConfig: { thankingSlide, questionsSlide, extraSlides }
  //   } = this.props;
  //
  //
  //   if (
  //     JSON.stringify(slidesList) !== JSON.stringify(slides) ||
  //     prevProps.presentationConfig.thankingSlide !== thankingSlide ||
  //     prevProps.presentationConfig.questionsSlide !== questionsSlide
  //   ) {
  //     this.setState({
  //       slidesList: clonedeep(slides),
  //       // slides: clonedeep(slides),
  //       nbSlides: slides.length
  //     });
  //     // setTimeout(() => this.addExtraSlides(), 50);
  //   }
  // }

  handleSlidePageChange = ({ selected }) => {
    const {
      dispatch,
      year,
      data: { slides }
    } = this.props;
    dispatch(setPresentationCurrentSlideIndex(selected));
    this.setState({ index: selected });
    dispatch(setCommentSlideCode(slides[selected].code));
    let searchParams = browserHistory().location.search;
    const { organization } = this.props;
    window.history.pushState(
      "",
      "",
      `/prepare-presentation/${organization.uen}/${selected + 1}` +
        (searchParams.includes("year") ? "" : `?year=${year}`) +
        searchParams
    );
    this.props.onPageChange(selected);
  };

  removeExtraSlides = () => {
    let {
      presentationConfig: { thankingSlide, questionsSlide }
      // data: { slides }
    } = this.props;

    let { slidesList, index, nbSlides } = this.state;

    let countSlides = nbSlides;

    // let slidesList = clonedeep(slides);

    if (slidesList) {
      /////**********************     CONCLUSION_SLIDE     ************************///
      // if (
      //   !extraSlides.enabled &&
      //   slidesList.find(slide => slide.layout.type === "EXTRA_SLIDE")
      // ) {
      //   this.handleSlidePageChange({
      //     selected: 0
      //   });
      //
      //   countSlides -= extraSlides.slides.length;
      //
      //   // countSlides--;
      //   this.setState({
      //     slidesList: slidesList.filter(
      //       slide => slide.layout.type !== "EXTRA_SLIDE"
      //     ),
      //     nbSlides: countSlides
      //   });
      // }

      /////**********************     THANKING_SLIDE     ************************///
      if (
        !thankingSlide &&
        slidesList.find(slide => slide.layout.type === "THANKING_SLIDE")
      ) {
        this.handleSlidePageChange({
          selected: slidesList.length === index + 1 ? index - 1 : index
        });

        countSlides--;
        this.setState({
          slidesList: slidesList.filter(
            slide => slide.layout.type !== "THANKING_SLIDE"
          ),
          nbSlides: countSlides
        });
      }

      /////**********************     QUESTIONS_SLIDE     ************************///
      if (
        !questionsSlide &&
        slidesList.find(slide => slide.layout.type === "QUESTIONS_SLIDE")
      ) {
        this.handleSlidePageChange({
          selected: slidesList.length === index + 1 ? index - 1 : index
        });

        countSlides--;
        this.setState({
          slidesList: slidesList.filter(
            slide => slide.layout.type !== "QUESTIONS_SLIDE"
          ),
          nbSlides: countSlides
        });
      }
    }
  };

  addExtraSlides = () => {
    const {
      presentationConfig: { thankingSlide, questionsSlide }
      // data: { slides }
    } = this.props;

    let { slidesList, nbSlides } = this.state;

    let countSlides = nbSlides;

    // let countSlides = slides.length;

    // let slidesList = clonedeep(slides);

    if (slidesList) {
      /////**********************     CONCLUSION_SLIDE     ************************///
      // if (
      //   extraSlides.enabled &&
      //   extraSlides.slides.length > 0 &&
      //   !slidesList.find(slide => slide.layout.type === "EXTRA_SLIDE")
      // ) {
      //   // let slides = slidesList.filter(
      //   //   slide =>
      //   //     !["THANKING_SLIDE", "QUESTIONS_SLIDE"].includes(slide.layout.type)
      //   // );
      //
      //   countSlides = slidesList.length;
      //
      //   extraSlides.slides.forEach(item => {
      //     slidesList.splice(item.page - 1, 0, {
      //       id: 0,
      //       label: item.title,
      //       layout: {
      //         label: item.title,
      //         type: "EXTRA_SLIDE",
      //         config: {
      //           background: "url(/img/back_blue.png)",
      //           componentsBackground: "#FFFFFF"
      //         },
      //         components: [item]
      //       }
      //     });
      //     countSlides++;
      //   });
      //
      //   this.setState({
      //     slidesList: slidesList,
      //     nbSlides: countSlides
      //   });
      // }
      /////**********************     THANKING_SLIDE     ************************///
      if (
        thankingSlide
        // !slidesList.find(slide => slide.layout.type === "THANKING_SLIDE")
      ) {
        slidesList = slidesList.filter(
          slide => slide.layout.type !== "QUESTIONS_SLIDE"
        );
        countSlides = slidesList.length;

        slidesList.push({
          id: 0,
          layout: {
            labels: { fr: "Remerciement", en: "", nl: "" },
            type: "THANKING_SLIDE",
            config: {
              background: "url(/img/back_blue.png)",
              componentsBackground: "#FFFFFF"
            },
            data: {}
          }
        });
        countSlides++;

        this.setState({
          slidesList: slidesList,
          nbSlides: countSlides
        });
      }

      /////**********************     QUESTIONS_SLIDE     ************************///
      if (
        questionsSlide
        // !slidesList.find(slide => slide.layout.type === "QUESTIONS_SLIDE")
      ) {
        slidesList.push({
          id: 0,
          layout: {
            label: { fr: "Questions", en: "", nl: "" },
            type: "QUESTIONS_SLIDE",
            config: {
              background: "url(/img/back_blue.png)",
              componentsBackground: "#FFFFFF"
            },
            data: {}
          }
        });
        countSlides++;

        this.setState({
          slidesList: slidesList,
          nbSlides: countSlides
        });
      }
    }
  };

  render() {
    let {
      organization,
      comments,
      data: { slides, extraInfos },
      presentationConfig: { hiddenSlides },
      currentSlideIndex,
      withoutHeader,
      currentOrganization
    } = this.props;

    return (
      <div
        className={classnames(
          styles.scaled_slide,
          withoutHeader ? styles.without_header : ""
        )}
      >
        <div
          className={styles.diaporama_slide}
          onKeyDown={() => this.onKeyPressed}
          tabIndex="0"
        >
          {!this.props.hideIframe ? <div className={styles.iframe_mask} /> : ""}
          <div className={styles.diaporama_header}>
            <div className={`large-11 medium-11 small-11 ${styles.title}`}>
              {_("balanceSheet")} {organization.name}
            </div>
          </div>
          <div
            className={classnames(
              styles.shadow_box,
              slides[currentSlideIndex] &&
              slides[currentSlideIndex].id !== 0 &&
              hiddenSlides.find(code => code === slides[currentSlideIndex].code)
                ? styles.hidden
                : ""
            )}
          >
            {slides[currentSlideIndex] ? (
              <Slide
                key={currentSlideIndex}
                slide={slides[currentSlideIndex]}
                handleDisplayAnnexePDF={this.props.handleDisplayAnnexePDF}
                comments={comments}
                isPresentation={true}
                isPreparePresentation={true}
                explanations={this.props.indicatorsExplanation}
                extraInfos={extraInfos}
                currentOrganization={currentOrganization}
              />
            ) : (
              <NotFoundV2 errorPageType={"ERROR_404"} buttonIgnored={true} />
            )}
          </div>
          <div className={styles.diaporama_footer}>
            <ReactPaginate
              previousLabel={_("previous")}
              nextLabel={_("next")}
              breakLabel={<a href="">...</a>}
              breakClassName={""}
              pageCount={slides.length}
              marginPagesDisplayed={1}
              pageRangeDisplayed={2}
              onPageChange={this.handleSlidePageChange}
              containerClassName={"dark_pagination"}
              subContainerClassName={`pages dark_pagination`}
              activeClassName={"current"}
              pageClassName="page"
              forcePage={currentSlideIndex}
            />
            <AnnexeIframe
              hideIframe={this.props.hideIframe}
              srcIframe={this.props.srcIframe}
              loadingIframe={this.props.loadingIframe}
              onCloseIframe={this.props.onCloseIframe}
              isNotFound={this.props.isNotFound}
            />
          </div>
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  comments: state.preparePresentation.items.comments,
  indicatorsExplanation: state.indicatorsExplanation.items,
  presentationConfig: state.presentation.presentationConfig,
  currentSlideIndex: state.presentation.currentSlideIndex,
  withoutHeader: state.auth.withoutHeader
});

export default connect(mapStateToProps)(SlidesPresentation);



// WEBPACK FOOTER //
// ./src/components/PreparePresentation/SlidesPresentation.js